var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"1"}}),_vm._l((_vm.days),function(day,i){return _c('v-col',{key:i,attrs:{"cols":"1"}},[_c('v-label',[_c('span',{staticClass:"day-labels ml-1"},[_vm._v(_vm._s(day))])])],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }